import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import React, { ReactNode } from 'react';

import { RootState } from '../store';

interface IButtonContent {
  label: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  type?: 'primary' | 'secondary';
  shouldStretch?: boolean;
}

export interface IModalContent {
  title?: ReactNode | Element;
  description?: ReactNode | Element;
  onClose?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  displayClose?: boolean;
  canClickOutside?: boolean;
  buttons?: IButtonContent[];
}

export type DBFile = {
  created_at: string;
  file_name: string;
  id: number;
  name: string;
  url: string;
};

export type ReportFile = {
  name: string;
  id: number;
  created_at: string;
  isReport: boolean;
  type: string;
};

export type GeneratedCSVFile = {
  id: number;
  created_at: string;
  file_name: string;
  csv_data: string;
  name: string;
};

interface IFileUploadModal {
  isFileUploadModalOpen: boolean;
  isFetchingFiles: boolean;
  fileUploadModalTitle: string;
  files: (DBFile | ReportFile | GeneratedCSVFile)[];
  title: string;
}

const initialState: IFileUploadModal = {
  fileUploadModalTitle: '',
  files: [],
  isFetchingFiles: false,
  isFileUploadModalOpen: false,
  title: '',
};

const modalSlice = createSlice({
  initialState,
  name: 'file-upload-modal',
  reducers: {
    clearFileUploadModal: (state: IFileUploadModal) => {
      Object.keys(state).forEach((key) => {
        state[key] = initialState[key];
      });
    },
    setFiles: (
      state: IFileUploadModal,
      action: PayloadAction<(DBFile | ReportFile | GeneratedCSVFile)[]>
    ) => {
      state.files = action.payload;
    },
    setIsFetchingFiles: (
      state: IFileUploadModal,
      action: PayloadAction<boolean>
    ) => {
      state.isFetchingFiles = action.payload;
    },
    setIsFileUploadModalOpen: (
      state: IFileUploadModal,
      action: PayloadAction<boolean>
    ) => {
      state.isFileUploadModalOpen = action.payload;
    },
    setTitle: (state: IFileUploadModal, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
  },
});

const fileUploadModalSelector = (state: RootState) => state.fileUploadModal;
export const isFileUploadModalOpenSelector = (state: RootState) =>
  fileUploadModalSelector(state).isFileUploadModalOpen;

export const {
  clearFileUploadModal,
  setFiles,
  setIsFetchingFiles,
  setIsFileUploadModalOpen,
  setTitle,
} = modalSlice.actions;

export default modalSlice.reducer;
